import { useSelector } from "react-redux";
import productUnitPriceDisplay, {
  productPriceDisplay,
} from "../utils/productPriceDisplay";
import toPriceDisplay from "../utils/toPriceDisplay";
import {
  getDiscountPercent,
  getProductPrices,
} from "../utils/productPromotion";

// Acima disso a pílula de desconto sai laranja em vez de verde, como no iFood.
const HIGH_DISCOUNT_PERCENT = 30;

/**
 * O preço do produto na vitrine e na tela do produto.
 *
 * Com promoção vigente, segue o iFood: o preço promocional, o cheio riscado
 * e a porcentagem de desconto numa pílula.
 * A vigência depende da hora, então é resolvida aqui, no render: o menu é
 * publicado sob demanda e um preço congelado na publicação nunca começaria
 * nem terminaria sozinho.
 */
export default function ProductPriceLabel({ product, className }) {
  const utcOffsetMinutes = useSelector((state) => state.shop.utcOffsetMinutes);
  const prices = getProductPrices(product, new Date(), utcOffsetMinutes);

  if (!prices.isPromotional) {
    return (
      <span className={className}>{productUnitPriceDisplay(product)}</span>
    );
  }

  const percent = getDiscountPercent(prices);
  const pillColor =
    percent > HIGH_DISCOUNT_PERCENT
      ? "discount-pill-high"
      : "discount-pill-low";

  return (
    <span className={className}>
      {productPriceDisplay(product, prices.minPrice)}
      <s className="text-muted fw-normal ms-1">
        {toPriceDisplay(prices.fullMinPrice)}
      </s>
      <span className={`discount-pill ${pillColor} ms-2`}>-{percent}%</span>
    </span>
  );
}
